export const showLoader = (showLoader) => {
    return {
        type: "SHOW_LOADER",
        showLoader
    }
};